var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyCodeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34013 0C1.49543 0 0 1.49425 0 3.33751V7.4626C0 7.70302 0.195056 7.89793 0.43567 7.89793C0.676283 7.89793 0.871339 7.70302 0.871339 7.4626V3.33751C0.871339 1.9751 1.97666 0.870655 3.34013 0.870655H7.41385C7.65447 0.870655 7.84952 0.675752 7.84952 0.435328C7.84952 0.194903 7.65447 0 7.41385 0H3.34013Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80201 2.05664C6.91937 1.84639 4.98896 1.84639 3.10631 2.05664C2.56999 2.11653 2.139 2.53828 2.07579 3.07833C1.8525 4.98593 1.8525 6.91302 2.07579 8.82062C2.139 9.36068 2.56999 9.78242 3.10631 9.84231C4.98896 10.0526 6.91937 10.0526 8.80201 9.84231C9.33834 9.78242 9.76932 9.36068 9.83254 8.82062C10.0558 6.91302 10.0558 4.98593 9.83254 3.07833C9.76932 2.53828 9.33834 2.11653 8.80201 2.05664ZM3.2031 2.92191C5.02142 2.71884 6.8869 2.71884 8.70523 2.92191C8.84311 2.9373 8.9515 3.04626 8.9671 3.17947C9.18252 5.01987 9.18252 6.87908 8.9671 8.71948C8.9515 8.8527 8.84311 8.96165 8.70523 8.97705C6.8869 9.18011 5.02142 9.18011 3.2031 8.97705C3.06522 8.96165 2.95682 8.8527 2.94123 8.71948C2.72581 6.87908 2.72581 5.01987 2.94123 3.17947C2.95682 3.04626 3.06522 2.9373 3.2031 2.92191Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCodeWhite);
export default __webpack_public_path__ + "static/media/CopyCodeWhite.bf3c8d85a2c7efd3474562d03b3a9b47.svg";
export { ForwardRef as ReactComponent };